import { render, staticRenderFns } from "./CarouselNavigation.vue?vue&type=template&id=72e7fdf3&scoped=true"
import script from "./CarouselNavigation.vue?vue&type=script&lang=js"
export * from "./CarouselNavigation.vue?vue&type=script&lang=js"
import style0 from "./CarouselNavigation.vue?vue&type=style&index=0&id=72e7fdf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7fdf3",
  null
  
)

export default component.exports